export class CollectionSubnav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els?.link?.elements.forEach((link) => {
      this.listeners.add(link, 'click', this.handleClick.bind(this))
    })
  }

  handleClick (e) {
    const link = e.target.closest('[data-collection-subnav-el="link"]')

    if (!link) return

    const linkUrl = new URL(link.href, window.location.origin)

    if (linkUrl.pathname !== window.location.pathname) return

    e.preventDefault()

    const form = document.querySelector('form[is="collection-filters-form"]')
    if (!form) return

    const searchParams = linkUrl.search ? linkUrl.search.slice(1) : ''

    form.renderPage({ searchParams })
  }
}

if (!customElements.get('collection-subnav')) {
  customElements.define('collection-subnav', CollectionSubnav)
}
